const leadsService = {
  async getLeads(payload) {
    try {
      const { data } = await axios.get("achgateway/leads", {
        params: payload
      });

      return { leads: data.leads };
    } catch (error) {
      throw error;
    }
  },
  async getLead(payload) {
    try {
      const { leadId } = payload

      const { data } = await axios.get(`achgateway/leads/${leadId}`);

      return { lead: data.lead };
    } catch (error) {
      throw error;
    }
  }
};

module.exports = leadsService;
